module.exports = __webpack_public_path__ + "static/media/jilongshanicon.77df08cb.webp";